<template>
    <header id="album-header" :class="['header', `header--${album.header_type}`, {'-is-mobile': isMobile}]"
            :style="album.header_type === 'fullscreen' && headerBackground ? `background-image: url(${headerBackground})` : ''">
        <div class="container">
            <div class="header-inner">
                <div class="header-image" v-if="album.header_type === 'description_and_picture' && headerBackground"
                     :style="`background-image: url(${headerBackground})`"></div>
                <div class="row">
                    <div class="col-md-8">
                        <h1 class="header-title">{{ album.title || $t('no_name') }}</h1>
                        <p class="header-info">
                            <!--{{ album.created_at | moment('DD.MM.YYYY') }} /-->
                            {{ $tc('n_photos', albumPhotos ? albumPhotos.length : 0, {amount_total_photos: albumPhotos ?
                            albumPhotos.length : 0}) }}
                        </p>
                        <div class="header-description" v-if="album.description_main && album.header_type !== 'default'"
                             v-html="album.description_main"></div>
                    </div>
                    <div v-if="album.header_type === 'with_password'" class="col-md-4">
                        <hidden-album-form :label="!isMobile" position="left"/>
                    </div>
                </div>
            </div>
        </div>
        <button v-if="album.header_type === 'fullscreen'" @click="scrollDown()"
                class="btn btn-outline-light btn-icon-left header-show-photos-action">
            <span class="material-icon icon-keyboard_arrow_down"/>
            {{ $t('show_photos') }}
        </button>
    </header>
</template>

<style lang="scss">
    @import "../../scss/variables";

    .header {
        position: relative;
        padding: 150px 0 80px;
        background-color: var(--bg-secondary-color);

        &.-is-mobile {
            padding: 100px 0 60px;

            .header-image {
                margin-bottom: 20px;
            }
        }

        &--with_password,
        &--default {
            padding: 115px 0 25px;

            &.-is-mobile {
                padding: 130px 0 40px;
            }

            .header {

                &-title {
                    margin-bottom: 10px;
                }
            }
        }

        &--with_password {

            .header {

                &-title,
                &-info,
                &-description {
                    padding-right: 180px;
                }
            }

            &.-is-mobile {

                .header {

                    &-title,
                    &-info,
                    &-description {
                        padding-right: 0;
                    }
                }
            }
        }

        &--fullscreen {
            padding: 0;
            min-height: 100vh;
            color: #fff;
            background: #eee url('../../assets/no-preview-large.jpg') 50% 50% no-repeat;
            background-size: cover;

            &.-is-mobile {
                display: flex;
                min-height: calc(100vh - 80px);
                flex-direction: column;
                justify-content: flex-end;

                > .container {
                    position: static;
                    width: 100%;
                    max-width: 100%;
                    padding-top: 0;
                    padding-bottom: 0;
                    margin-bottom: 30px;
                    transform: none;
                }

                .header {

                    &-title {
                        font-size: 2.1rem;
                    }

                    &-info {
                        font-size: .87rem;
                    }

                    &-description {
                        font-size: .87rem;
                    }

                    &-show-photos-action {
                        position: static;
                        width: auto;
                        margin-left: 15px;
                        margin-right: auto;
                        margin-bottom: 30px;
                        transform: none;
                    }
                }
            }

            &::after {
                position: absolute;
                content: '';
                width: 100%;
                height: 100%;
                left: 0;
                bottom: 0;
                background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 1) 100%);
                opacity: .5;
            }

            > .container {
                position: relative;
                padding-top: 130px;
                padding-bottom: 70px;
                z-index: 1;

                @media (min-width: 768px) {
                    position: absolute;
                    left: 50%;
                    bottom: 100px;
                    transform: translateX(-50%);
                }
            }

            .header {

                &-title {
                    font-size: 3rem;
                    color: rgba(#fff, .87);
                }

                &-info {
                    color: #fff;
                }

                &-description {
                    font-size: 1.18rem;
                    color: #fff;
                }
            }

            .btn-light {
                background-color: var(--bg-color);
            }
        }

        &-image {
            height: 500px;
            margin: 20px 0 50px;
            background: 50% 50% no-repeat;
            background-size: cover;
        }

        &-title {
            margin: 20px 0 10px;
            font-size: 2.3rem;
            font-weight: normal;
            line-height: 1.2;
            color: var(--text-color);
        }

        &-info {
            font-size: .875rem;
            font-weight: 500;
            letter-spacing: .1px;
            color: var(--text-secondary-color);
        }

        &-description {
            margin-top: 30px;
            font-size: 1rem;
            letter-spacing: .59px;
            line-height: 1.7;
            color: var(--text-secondary-color);
        }

        .btn-light {
            background-color: var(--bg-color);

            &:hover {
                background-color: var(--bg-secondary-color);
            }
        }

        &-show-photos-action {
            position: absolute;
            bottom: 60px;
            left: 50%;
            text-transform: uppercase;
            transform: translateX(-50%);
            z-index: 1;

            .material-icon {
                position: relative;
                top: 2px;
            }
        }

        .hidden-album-form {
            margin-top: 35px;
        }
    }

    body.-is-mobile {

        .header-title {
            margin: 20px 0 10px;
            font-size: 1.75rem !important;
        }
    }
</style>

<script>
  import HiddenAlbumForm from '../../components/HiddenAlbumForm.vue';

  import header from 'src/mixins/headerComponent';

  export default {
    mixins: [header],
    components: {
      HiddenAlbumForm,
    },
  };
</script>
